import React from 'react';
import KeyPortsCard from './KeyPortsCard';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';

interface KeyPortsCardData {
  portsText?: string;
}

export default function KeyPortsCardRegistry(props: RegistryComponentProps): React.ReactElement {
  const data = getRegistryData<KeyPortsCardData>(props);
  const portsText =
    data.portsText ?? 'New Bedford, Gloucester, Boston, Portland, Narengassett';

  return <KeyPortsCard portsText={portsText} />;
}
